import type { WfxSessionData } from '@/services/wfx/types';

const WFX_SESSION_KEY = 'wfx_session';

export function getWfxSession(): WfxSessionData | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(WFX_SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as WfxSessionData;
  } catch {
    return null;
  }
}

export function setWfxSession(session: WfxSessionData): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(WFX_SESSION_KEY, JSON.stringify(session));
}

export function clearWfxSession(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(WFX_SESSION_KEY);
}

export function readGuidFromUrl(): string | null {
  if (typeof window === 'undefined') return null;
  const guid = new URLSearchParams(window.location.search).get('GUID');
  return guid && guid.trim() ? guid.trim() : null;
}

export function stripGuidFromUrl(): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has('GUID')) return;
  url.searchParams.delete('GUID');
  const search = url.searchParams.toString();
  const next = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
  window.history.replaceState(window.history.state, '', next);
}

export function mapSessionToCurrentUser(session: WfxSessionData) {
  return {
    name: session.UserName,
    userId: session.UserID,
    companyCode: session.CompanyCode,
    memberCompanyCode: session.MemberCompanyCode,
    companyDivisionCode: session.CompanyDivisionCode,
    userGroupID: session.UserGroupID,
    isAdmin: !!session.IsAdmin,
    isSuperAdmin: !!session.IsSuperAdmin,
    applicationURL: session.ApplicationURL,
    flags: {
      analytics: !!session.isAnalyticsEnabled,
      queueConfig: !!session.isQueueConfigEnabled,
      addWfxKey: !!session.isAddWfxKeyEnabled,
    },
    avatar: '',
    permissions: [] as any[],
  };
}
